import 'arrayq';
import { createSelector } from 'reselect';
import { PureConnect, React } from '../../react';
import { categoriesEditor } from './resource';
import cx from './style.less';
import windowSelectors from '../../window/selectors';
import { Modal } from '../modal';
import FocusLockFocusGuard from '../../focuslock/focuslockext';
import CategoriesEditArea, { CategoriesEditAreaButtons } from './categoryEditArea';
   
const isValidSelector = createSelector(
    categoriesEditor.selectors.item,
    (item) => item.name && item.color,
  );

export default PureConnect(`CategoryEditModal`)(
    (state) => ({
        creating: categoriesEditor.selectors.creating(state),
        isValid: isValidSelector(state),
        item: categoriesEditor.selectors.item(state),
        updating: categoriesEditor.selectors.updating(state),
        origin: state.notemenu.origin,
        screenSmall: windowSelectors.small(state),     
        flyoverVisible: state.flyover.visible,
    }),
    (dispatch) => ({       
        cancelCreating: () => dispatch(categoriesEditor.actions.CREATE_CANCEL({ })),
        cancelUpdating: () => dispatch(categoriesEditor.actions.UPDATE_CANCEL({ })),
    }),
    ({ creating , updating, flyoverVisible, screenSmall,  cancelCreating, cancelUpdating }) => {
        const onCancel = creating ? cancelCreating : cancelUpdating;
        return (
           <Modal onEscKeyDown={ ()=> onCancel()} 
                  visible={!flyoverVisible && (creating || updating)} 
                  type={screenSmall ? 'smallscreen': 'center2nd' }
                  backdrop={true}               
                  header={<div className={cx('app')}></div>}
                >                   
                <div className={cx(!(creating || updating) ? 'wcag-invisible' : '', 'fields-container')}  
                    aria-hidden={!(creating || updating)} 
                    aria-labelledby= "Wijzig een categorie">
                    <FocusLockFocusGuard disabled={!(creating || updating)}>   
                    <div className={cx('note-details', !flyoverVisible && (creating || updating) ? '': 'wcag-invisible')}>
                        <CategoriesEditArea />
                        <CategoriesEditAreaButtons />
                    </div>
                    </FocusLockFocusGuard>
                </div>         
            </Modal> 
        );
    });



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/categories/categoryEditModal.tsx